module.exports = __webpack_public_path__ + "images/videoCaseStudy-icon-city.svg?h=182fcc905055ad263a1122bf86159770";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/videoCaseStudy-icon-city.svg
// module id = 2043
// module chunks = 12 15